module.exports = __webpack_public_path__ + "assets/img/pdf-icon-mob.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/pdf-icon-mob.svg
// module id = 698
// module chunks = 0